"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.ChatNotificationType=void 0;var r;(function(e){e.CustomerCourier="customer-courier",e.Proactive="proactive",e.Support="support"})(r||(exports.ChatNotificationType=r={}));
//# sourceMappingURL=ChatNotificationType.js.map
